// extracted by mini-css-extract-plugin
export default {"cthBox":"CustomTableHeader_cthBox__iJomx","cthItem":"CustomTableHeader_cthItem__PGpSO"};